<template>
  <span title="拖拽排序" class="j-sort show-title">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      :style="style()"
      class="icon-sort"
      role="img"
      width="32"
      height="32"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M6.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L8 7.414V19a1 1 0 1 1-2 0V7.414L3.707 9.707a1 1 0 0 1-1.414-1.414l4-4zM16 16.586V5a1 1 0 1 1 2 0v11.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 16.586z"
      ></path>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      :style="style()"
      class="icon-drag"
      role="img"
      width="32"
      height="32"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 256 256"
    >
      <path fill="currentColor" d="M128 32h-20a56 56 0 0 0-56 56v24h76Z" opacity=".2"></path>
      <path
        fill="currentColor"
        d="M148 24h-40a64.1 64.1 0 0 0-64 64v80a64.1 64.1 0 0 0 64 64h40a64.1 64.1 0 0 0 64-64V88a64.1 64.1 0 0 0-64-64Zm48 64v16h-60V40h12a48 48 0 0 1 48 48Zm-88-48h12v64H60V88a48 48 0 0 1 48-48Zm40 176h-40a48 48 0 0 1-48-48v-48h136v48a48 48 0 0 1-48 48Z"
      ></path>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
    },
    top: {
      type: Number,
    },
  },
  methods: {
    style() {
      var sb = new StringBuilder()
      if (this.color) {
        sb.append('color: ' + this.color)
      }
      if (this.top) {
        sb.append('top: ' + this.top + 'px')
      }
      return sb.toString()
    },
  },
}
</script>
<style lang="less" scoped>
.j-sort {
  position: relative;
  top: 0px;
  color: var(--color-primary-6);

  svg {
    vertical-align: sub;
    width: 18px;
    height: 18px;
    cursor: pointer;
    transition: all 0.3s;

    &.icon-drag {
      opacity: 0;
      position: absolute;
      margin-left: -18px;
    }
  }
}
</style>
